<script>
import Pagination from "@/components/_Shared/Pagination";
import PreloaderTable from "@/components/_Shared/PreloaderTable";

export default {
  data() {
    return {
      preloader: false
    };
  },
  components: {
    Pagination,
    PreloaderTable
  }
};
</script>

<template>
  <div class="box">
    <div class="title mb-40">Histórico de saques</div>

    <transition name="fade" mode="out-in">
      <PreloaderTable v-if="preloader"/>
      <div key="1" v-else class="table">
        <table>
          <thead>
            <tr>
              <th>Data</th>
              <th>Valor</th>
              <th>Status</th>
            </tr>
          </thead>

          <transition name="fade" mode="out-in">
            <tbody>
              <tr v-for="n in 10" :key="n">
                <td>15/10/2018 - 10:36</td>
                <td>R$ 60,00</td>
                <td>encaminhado</td>
              </tr>
            </tbody>
          </transition>
        </table>

        <Pagination :pagination="pagination" @changePage="setCurrentPage($event)"/>
      </div>
    </transition>
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/WalletOfCompany/History.vue